<div class="heading-container">
    <mat-icon *ngIf="hasBackButton" color="primary" class="heading-icon" #backTooltip="matTooltip" [matTooltip]="tooltip" aria-label="back" (click)="back()">arrow_back</mat-icon>
    <h1 align="center">{{heading}}</h1>
</div>
